/**
 * Development Environment Configuration
 */
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAQhE5Q46gog3ffEc9wrf5wf2JpSAVxjls",
    authDomain: "keyboardkey-dev.firebaseapp.com",
    projectId: "keyboardkey-dev",
    storageBucket: "keyboardkey-dev.firebasestorage.app",
    messagingSenderId: "332995094000",
    appId: "1:332995094000:web:74fd1673f2f830385a2935",
    measurementId: "G-NEKFX1YPDL"
  }
};


